import { render } from "./PixelGame.vue?vue&type=template&id=1dfdc197&ts=true"
import script from "./PixelGame.vue?vue&type=script&lang=ts"
export * from "./PixelGame.vue?vue&type=script&lang=ts"

import "./PixelGame.vue?vue&type=style&index=0&id=1dfdc197&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__